/**
 * Логотип Aptile — только начертание, вырезанное из фирменного логотипа
 * (`pictures/logo.png`) с прозрачным фоном, залитое сплошной бирюзой
 * палитры — в обеих темах одного цвета.
 *
 * Ведёт на главный экран: привычный для веб-приложений путь «домой».
 */

import { Link } from 'react-router-dom';

import wordmark from '../../assets/wordmark.png';
import { useTranslation } from 'react-i18next';

/** Пропорции `wordmark.png` (ширина / высота). */
const WORDMARK_RATIO = 735 / 235;
/** Бирюза палитры (`teal` в токенах), не зависит от темы. */
const LOGO_TEAL = '#8CC4C4';

interface LogoProps {
  readonly className?: string;
}

export function Logo({ className }: LogoProps) {
  const { t } = useTranslation();
  return (
    <Link
      to="/dashboard"
      aria-label={t('common.homeLink')}
      className={['group flex min-h-11 shrink-0 items-center rounded-lg', className ?? ''].join(' ')}
    >
      {/* Начертание из PNG служит маской, заливка — сплошная бирюза палитры (#8CC4C4),
          без градиента и одинаковая в светлой и тёмной теме. */}
      <span
        role="img"
        aria-label="Aptile"
        className="block h-7 select-none transition-transform duration-200 group-hover:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:transform-none"
        style={{
          aspectRatio: `${WORDMARK_RATIO}`,
          background: LOGO_TEAL,
          WebkitMask: `url(${wordmark}) center / contain no-repeat`,
          mask: `url(${wordmark}) center / contain no-repeat`,
        }}
      />
    </Link>
  );
}
